export default __webpack_public_path__ + "static/media/logo-cmtech-login.08c41bf8.png";